import { Card, CardContent, Divider, Stack, TextField, Typography } from '@mui/material';

const CARD_TITLE = 'Step 1 : Role Details';
const LABEL_ROLE_NAME = 'Role Name';
const LABEL_DESCRIPTION = 'Description';
const SUMMARY_TITLE = 'Summary';
const TOTAL_PERMISSION = 'Total permission';
const MODULES_CONFIGURED = 'Modules configured';

const cardStyles = {
    width: '100%',
};

export type RoleDetailsCardProps = {
    name: string;
    description: string;
    onNameChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
    totalPermissionCount: number;
    modulesConfiguredCount: number;
};

const RoleDetailsCard = ({
    name,
    description,
    onNameChange,
    onDescriptionChange,
    totalPermissionCount,
    modulesConfiguredCount,
}: RoleDetailsCardProps) => (
    <Card variant="outlined" sx={cardStyles} data-testid="access-center-create-role-details-card">
        <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
                {CARD_TITLE}
            </Typography>
            <Stack spacing={2} sx={{ mt: 2 }}>
                <Stack spacing={1}>
                    <Typography variant="body2" color="text.secondary">
                        {LABEL_ROLE_NAME}
                    </Typography>
                    <TextField
                        value={name}
                        onChange={(e) => onNameChange(e.target.value)}
                        placeholder="Enter role name"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputProps={{ 'data-testid': 'access-center-create-role-name-input' }}
                    />
                </Stack>
                <Stack spacing={1}>
                    <Typography variant="body2" color="text.secondary">
                        {LABEL_DESCRIPTION}
                    </Typography>
                    <TextField
                        value={description}
                        onChange={(e) => onDescriptionChange(e.target.value)}
                        placeholder="Enter description"
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        minRows={2}
                        inputProps={{ 'data-testid': 'access-center-create-role-description-input' }}
                    />
                </Stack>
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" fontWeight={600}>
                    {SUMMARY_TITLE}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {TOTAL_PERMISSION} : {totalPermissionCount}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {MODULES_CONFIGURED} : {modulesConfiguredCount}
                </Typography>
            </Stack>
        </CardContent>
    </Card>
);

export default RoleDetailsCard;
